export default "__VITE_ASSET__CY9LTD1q__"